import { createRoute, useParams } from "@tanstack/solid-router";
import { MODALITY_IN_PERSON_KEY } from "@space/shared";
import { appRoute } from "./route";
import { withFeatureGate } from "@/features/flags/feature-gate";
import { OccupancyView } from "@/features/academy/components/occupancy-view";

function AcademyCampusOccupancyPage() {
  const params = useParams({ from: "/u/$u/academy/campuses/$campusId" });
  return <OccupancyView campusId={params().campusId} />;
}

export const academyCampusOccupancyRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/campuses/$campusId",
  // §L1 · online-first: la ocupación de aulas es infraestructura PRESENCIAL.
  component: withFeatureGate(MODALITY_IN_PERSON_KEY, AcademyCampusOccupancyPage),
});
